module.exports = __webpack_public_path__ + "img/banner1.d2d994c0.png";